import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import { listPaginationLoaderDeps } from '../../list/pagination/list-pagination-loader-deps.ts';
import type { processDefinitionsQuery } from '../../process-definitions/__generated__/processDefinitionsQuery.graphql.ts';
import relayReq from '../../process-definitions/__generated__/processDefinitionsQuery.graphql.ts';
import type { processDefinitionsQueryFragment$data } from '../../process-definitions/__generated__/processDefinitionsQueryFragment.graphql.ts';
import { ProcessDefinitions } from '../../process-definitions/process-definitions.tsx';
import { processDefinitionsSearchSchema } from '../../process-definitions/process-definitions-search-schema.ts';
import { relayEnv } from '../../relay/relay-env.ts';

type TProcessDefinitionKeys = keyof processDefinitionsQueryFragment$data['content'][number];

export const Route = createFileRoute('/_index/process-definitions')({
    component: ProcessDefinitions,
    // errorComponent: () => <div>err</div>,
    loaderDeps: ({ search: { pageNum, pageSize, search, sortBy, sortDir } }) => ({
        ...listPaginationLoaderDeps(pageNum, pageSize),
        search,
        sortBy,
        sortDir,
    }),
    loader: (ctx) => {
        const searchBy: TProcessDefinitionKeys[] = [
            'id',
            'definitionKey',
            'definitionName',
            'definitionVersion',
            'status',
        ];
        return loadQuery<processDefinitionsQuery>(
            relayEnv,
            relayReq,
            {
                ...ctx.deps,
                searchBy,
                filter: {
                    siteUrl: { eq: ctx.context.site?.siteUrl },
                    status: { notIn: ['ARCHIVED', 'TEMPLATE'] },
                },
            },
            { fetchPolicy: 'store-and-network' }
        );
    },
    validateSearch: processDefinitionsSearchSchema,
});
